import {
  Row,
  Col,
  Container,
  Form,
  Button,
  CloseButton,
  Table,
  Alert,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MaskedInput from 'react-text-mask';
import GoBackButton from "./GoBackButton";

const CreateNoteBookComponent = ({ createNoteBookApiRequest }) => {
  const [validated, setValidated] = useState(false);
  const [onboard, setOnboard] = useState("");
  const [createdDate, setCreatedDate] = useState(new Date().toISOString().split("T")[0])
  const [createNoteBookResponseState, setCreateNoteBookResponseState] =
    useState({
      message: "",
      error: "",
    });
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;
    const formInputs = {
      companyName: form.companyName.value,
      contactPerson: form.contactPerson.value,
      contactEmail: form.contactEmail.value,
      createdDate: form.createdDate.value,
      notes: form.notes.value,
      onboard: onboard,
      signedBy: userInfo?.email
    };

    if (event.currentTarget.checkValidity() === true) {
      createNoteBookApiRequest(formInputs)
        .then((data) => {
          if (data.message === "Note Book Created")
            navigate("/admin/salesNotes");
        })
        .catch((er) => {
          setCreateNoteBookResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          });
        });
    }
    setValidated(true);
  };
  const checkKeyDown = (e) => {
    if (e.code === "Enter") e.preventDefault();
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-5 content-container">
        <Row>
          <Col md={1}>
            {/* <Link to="/admin/NoteBooks" className="btn btn-info my-3">
              Go Back
            </Link> */}
            <GoBackButton />
          </Col>
          <Col md={8}>
            <h1>Create New Note</h1>
            <Form
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
              onKeyDown={(e) => checkKeyDown(e)}
            >
              <Form.Group className="mb-3" controlId="formBasicCompanyName">
                <Form.Label>Company Name</Form.Label>
                <Form.Control name="companyName" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicContactPerson">
                <Form.Label>Contact Person</Form.Label>
                <Form.Control name="contactPerson" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicContactEmail">
                <Form.Label>Contact Email</Form.Label>
                <Form.Control name="contactEmail" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicCreatedDate">
                <Form.Label>Date</Form.Label>
                <Form.Control name="createdDate"
                  type="date"
                  value={createdDate}
                  onChange={(e) => setCreatedDate(e.target.value)}
                  required
                  style={{ width: '300px' }} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control name="notes" required as="textarea" rows={6} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formRadioOptions">
                <Form.Label>Response</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Yes"
                    name="onboard"
                    value="YES"
                    checked={onboard === "YES"}
                    onChange={(e) => setOnboard(e.target.value)}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="No"
                    name="onboard"
                    value="NO"
                    checked={onboard === "NO"}
                    onChange={(e) => setOnboard(e.target.value)}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Maybe"
                    name="onboard"
                    value="MAYBE"
                    checked={onboard === "MAYBE"}
                    onChange={(e) => setOnboard(e.target.value)}
                  />
                </div>
              </Form.Group>

              <Button variant="primary" type="submit">
                Create
              </Button>
              <Link
                to="/admin/salesNotes"
                className="btn btn-secondary ms-5"
              >
                Cancel
              </Link>
              <p></p>
              {createNoteBookResponseState.error ?? ""}
            </Form>
          </Col>
        </Row>
      </Row>
    </Container>
  );
};

export default CreateNoteBookComponent;
